export const GET_CITATION_DETAIL = "GET_CITATION_DETAIL";
export const SET_CITATION_DETAIL = "SET_CITATION_DETAIL";
export const APPEAL_CITATION = "APPEAL_CITATION";
export const APPEAL_REPLY_CITATION = "APPEAL_REPLY_CITATION";
export const PAY_CITATION = "PAY_CITATION";

// export const PAY_CITATION_PAYMENT = "PAY_CITATION_PAYMENT";
export const getCitation = (data) => {
  return {
    type: GET_CITATION_DETAIL,
    payload: data,
  };
};
export const setCitation = (data) => {
  return {
    type: SET_CITATION_DETAIL,
    payload: data,
  };
};

export const appealCitation = (data) => {
  return {
    type: APPEAL_CITATION,
    payload: data,
  };
};
export const appealReplyCitation = (data) => {
  return {
    type: APPEAL_REPLY_CITATION,
    payload: data,
  };
};

export const payCitation = (data) => {
  return {
    type: PAY_CITATION,
    payload: data,
  };
};

// export const payCitationPayment = (data) => {
//   return {
//     type: PAY_CITATION_PAYMENT,
//     payload: data,
//   };
// };
